import { NavLink, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../Localization/Translation";
import { useLocation } from "react-router";
import { useEffect } from "react";
import Laundromats from "./Laundromats/Laundromats.js";
import AcceptedRequests from "./AcceptedRequests/AcceptedRequests.js";
import OfferRequests from "./OfferRequests/OfferRequests.js";

const mainTabClick = (newClassName) => {
  var newTab = document.querySelector(newClassName);

  Array.from(document.querySelectorAll(".main-tab")).forEach(function (val) {
    val.style.fontWeight = "normal";
  });
  newTab.style.fontWeight = "bold";
};

const MainLaundromats = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/Navbar/LaundryOwners/AllLaundromats")
      mainTabClick(".all-laundromats-tab");
    else if (location.pathname === "/Navbar/LaundryOwners/OfferRequests")
      mainTabClick(".offer-request-tab");
    else if (location.pathname === "/Navbar/LaundryOwners/AcceptedRequests")
      mainTabClick(".accepted-offers-tab");
  }, []);

  return (
    <div className="main-component">
      <div className="main-navbar" dir="auto">
        <NavLink
          to="/Navbar/LaundryOwners/AllLaundromats"
          className="all-laundromats-tab main-tab current-main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".all-laundromats-tab")}
        >
          {translate("all-laundromat-tap", locale)}
        </NavLink>
        <NavLink
          to="/Navbar/LaundryOwners/OfferRequests"
          className="offer-request-tab main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".offer-request-tab")}
        >
          {translate("offers-free-arrive-request-tap", locale)}
        </NavLink>
        <NavLink
          to="/Navbar/LaundryOwners/AcceptedRequests"
          className="accepted-offers-tab main-tab nav-link-main-navbar"
          onClick={() => mainTabClick(".accepted-offers-tab")}
        >
          {translate("offers-free-arrive-accepted-tap", locale)}
        </NavLink>
      </div>

      <Routes>
        <Route path="AllLaundromats/*" element={<Laundromats />} />
        <Route path="OfferRequests/*" element={<OfferRequests />} />
        <Route path="AcceptedRequests/*" element={<AcceptedRequests />} />
      </Routes>
    </div>
  );
};

export default MainLaundromats;
